<template lang="pug">
  div
    .container-cta.dark-cta(style='padding: 100px 0')
      .container-fluid
        .row
          .col-lg-3
          .col-lg-6.text-center
            h1.huge(style="padding-bottom: 10px") {{$parent.oneDecimal(wastedVotes)}}%
            h1(style='padding: 0 0 20px 0') voters unrepresented
            div(style='padding: 0 0 20px 0')
              template(v-if="$parent.page !== 'constituency' && $parent.data.constituencies.length < $parent.data.constituenciesTotal")
                |  So far,
              |  {{$parent.oneDecimal(wastedVotes)}}% of voters in {{place}} didn't vote for their MP.
              |  The way we elect MPs to Westminster means that our parliament doesn’t represent us.
              |  It’s time to make the seats in parliament match how we vote.
            a(href="https://action.electoral-reform.org.uk/page/3782/petition/1"
              target="_blank")
              button.btn Sign petition
    .container(v-if="$parent.page !== 'constituency' && $parent.data.constituencies.length < $parent.data.constituenciesTotal")
      .col-lg-3
      .col-lg-6.text-center
        seats-declared
</template>

<script>
import SeatsDeclared from './SeatsDeclared.vue'

export default {
  components: {
    SeatsDeclared,
  },
  name: 'SignPetition',
  computed: {
    wastedVotes() {
      return this.$parent.wastedVotes
    },
    place() {
      if (this.$parent.page === 'constituency') {
        return this.$parent.selectedConstituencyName
      }

      if (this.$parent.page === 'region') {
        return this.$parent.getPlaceName(this.$parent.selectedRegionName, true)
      }

      return 'the UK'
    }
  }
}
</script>
